import RedirectModal from "./RedirectModal";
export default RedirectModal;